import React from 'react';
import { TableHead } from './TableHead';
import { TableBody } from './TableBody';
import { ResponsiveTable } from "../../../../layout/Table/ResponsiveTable";

function TableComponent(props) {
    return (
      <div className="appointment-holidays-table-scroll">
        <ResponsiveTable>
          <TableHead
            applySort={ props.applySort } />
          <TableBody
            appointmentHolidays={ props.appointmentHolidays }
            actionCallback={ props.actionCallback }
          />
        </ResponsiveTable>
      </div>
    )
}

export { TableComponent };
